exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-notification[data-v-38065d10]{margin-left:0}.select-style[data-v-38065d10] .ui.selection.dropdown .menu{max-height:150px}.checkboxes-field label[data-v-38065d10]{display:block;padding-right:10px;padding-left:22px;text-indent:-22px}.checkboxes-field input[data-v-38065d10],.checkboxes-field label span[data-v-38065d10]{vertical-align:middle}.currency-select[data-v-38065d10]{max-width:70px}p[data-v-38065d10]{overflow:hidden}p[data-v-38065d10]:after{content:\"\";display:inline-block;height:.6em;vertical-align:bottom;width:100%;margin-right:-100%;margin-left:10px;border-top:1px solid #d3d3d3}", ""]);

// exports
